<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Production Template</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="accent" text to="/new-production-template">
              <v-icon left>mdi-plus</v-icon>New Template
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="records" :search="search"
              :mobile-breakpoint="zeroValue">

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/production-template/${item.id}`">
                  <v-icon left>mdi-eye</v-icon>  View Raw Materials
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    customersDialog: false,
    loader: false,
    zeroValue: 0,
    pageItems: 100,
    date: null,
    headers: [
      { text: "Product", value: "product.Name" },
      { text: "Total Production Cost", value: "totalLineSum" },
      { text: "Action", value: "action" },
    ],
    records: [],
    excelFile: null
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    getRecords() {
      const self = this;
      this.$store
        .dispatch("get", `/production-template`)
        .then(res => {
          console.log(res, " production res");
          if (res.ResultCode == 1200) {
            self.records = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getRecords();
  }
};
</script>